enum S3ACTIONTYPE {"UPLOAD" = "putObject", "DOWNLOAD" = "getObject", "DELETE" = "deleteObject"};
export default S3ACTIONTYPE;
